import { useTranslation } from "@refinedev/core";
import { IEventDetail } from "interfaces";
import { get } from "lodash";

export const MultilingualContent = ({
  eventDetailData,
}: {
  eventDetailData?: IEventDetail;
}) => {
  const { translate } = useTranslation();
  return (
    <div className="box-container">
      <div className="flex flex-col gap-y-4 text-sm">
        <div className="flex flex-col sm:flex-row gap-2">
          <p className="shrink-0 w-48 font-bold">
            {translate("eventSetup.eventInfo.multilingualContent.eventName")}:
          </p>
          <div className="flex flex-col gap-y-3">
            {(eventDetailData?.languages ?? []).map((language, index) => (
              <p key={index}>
                <img
                  src={`/images/flags/circle-${language}.png`}
                  alt="Flag icon"
                  className="inline mr-2.5"
                />
                {get(eventDetailData?.name, language, "") ?? ""}
              </p>
            ))}
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          <p className="shrink-0 w-48 font-bold">
            {translate("eventSetup.eventInfo.multilingualContent.eventPlace")}:
          </p>
          <div className="flex flex-col gap-y-3">
            {(eventDetailData?.languages ?? []).map((language, index) => (
              <p key={index}>
                <img
                  src={`/images/flags/circle-${language}.png`}
                  alt="Flag icon"
                  className="inline mr-2.5"
                />
                {get(eventDetailData?.place, language, "") ?? ""}
              </p>
            ))}
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          <p className="shrink-0 w-48 font-bold">
            {translate(
              "eventSetup.eventInfo.multilingualContent.displayOrganizationName"
            )}
            :
          </p>
          <div className="flex flex-col gap-y-3">
            {(eventDetailData?.languages ?? []).map((language, index) => (
              <p key={index}>
                <img
                  src={`/images/flags/circle-${language}.png`}
                  alt="Flag icon"
                  className="inline mr-2.5"
                />
                {get(eventDetailData?.merchant_name, language, "") || (
                  <span className="text-gray-400">N/A</span>
                )}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
